var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuredocSignatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161724",
    "data-name": "Group 161724",
    transform: "translate(-323 -299)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1941",
    "data-name": "Rectangle 1941",
    width: 23,
    height: 23,
    rx: 4,
    transform: "translate(323 299)",
    fill: "#cefbde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "signature-svgrepo-com",
    d: "M13.322,66.717c-1.105.075-2.682,1.167-3.48,1.525a4.416,4.416,0,0,1-1.624.521c-.482,0-.555-.346-.454-1.107.023-.171.25-1.69-.911-1.624-.535.032-1.372.529-3.616,2.688l.885-2.212a1.843,1.843,0,0,0-2.767-2.193L.184,65.1a.343.343,0,0,0-.1.471l.367.576a.339.339,0,0,0,.471.1l1.237-.83a.476.476,0,0,1,.7.578l-2.1,5.24a.682.682,0,0,0,.634.937.675.675,0,0,0,.482-.2c.9-.9,3.3-3.215,4.506-4.177a2.214,2.214,0,0,0,.439,1.788,1.8,1.8,0,0,0,1.4.54,5.4,5.4,0,0,0,2.182-.64c.7-.316,2.112-1.336,2.953-1.4a.343.343,0,0,0,.324-.337v-.685A.338.338,0,0,0,13.322,66.717Z",
    transform: "translate(328.843 242.427)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredocSignatureIcon);
export default __webpack_public_path__ + "static/media/securedoc-signature-icon.a2bcf94c12fbb3e83cd45d636ceab589.svg";
export { ForwardRef as ReactComponent };